var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Box, Flex } from "theme-ui";
import { ArtDirectedImage, CategoryCardText, ContentColorModeEnums, ImageVariants } from "../../index";
export const CategoryCard = (_a) => {
    var { section, title, message, ratio = ImageVariants.ratio_3x4, mode = ContentColorModeEnums.light, videoURL, hlsVideoURL, imageUrl, imageNode, imageAlt, hasGradientOverlay = true, objectPositionLeft = "center", objectPositionTop = "center", children } = _a, props = __rest(_a, ["section", "title", "message", "ratio", "mode", "videoURL", "hlsVideoURL", "imageUrl", "imageNode", "imageAlt", "hasGradientOverlay", "objectPositionLeft", "objectPositionTop", "children"]);
    return (_jsxs(Flex, { sx: {
            flexDirection: "column",
            width: "100%",
            flex: 1
        }, children: [(imageNode || hlsVideoURL) && (_jsx(Box, { sx: {
                    mb: 24,
                    variant: `images.${ratio}`
                }, children: _jsx(ArtDirectedImage, { videoURL: videoURL, hlsVideoURL: hlsVideoURL, imageUrl: imageUrl, imageNode: imageNode, imageAlt: imageAlt, objectPositionLeft: objectPositionLeft, objectPositionTop: objectPositionTop, hasGradientOverlay: hasGradientOverlay }) })), _jsx(CategoryCardText, { section: section, title: title, message: message, mode: mode, children: children })] }));
};
//# sourceMappingURL=CategoryCard.js.map